// Brand constants
export const BRAND = {
  name: "Beaudoin",
  logoUrl: "https://customer-assets.emergentagent.com/job_vitrine-prompt/artifacts/m9q2ds7u_%F0%9D%95%AD%F0%9D%96%8A%F0%9D%96%86%F0%9D%96%9A%F0%9D%96%89%F0%9D%96%94%F0%9D%96%8E%F0%9D%96%93.png",
};

// Heraldic / chivalric assets provided by the client
export const HERALDRY = {
  knightsPainting: "https://customer-assets.emergentagent.com/job_vitrine-prompt/artifacts/nlzf67ff_knights-painting-maltese-cross.png",
  jerusalemCross: "https://customer-assets.emergentagent.com/job_vitrine-prompt/artifacts/9pbpplpy_M-200-R_LG.jpg",
  gothicCross: "https://customer-assets.emergentagent.com/job_vitrine-prompt/artifacts/84r1e569_a1330dded7fc02c0c5f1b8a6706a9469.jpg",
};

export const COLORS = {
  blood: "#7F1318",
  bloodDeep: "#4A0A0E",
  black: "#050505",
  bone: "#D4C5B9",
};
